// Service.js
import React, { useRef, useEffect } from "react";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Surgical from "../assets/sur.webp";
import Phy from "../assets/phy.webp";
import Prevention from "../assets/prev.jpg";
import Diag from "../assets/Diagonist.webp";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Pagination, Navigation } from "swiper/modules";
import thumb1 from "../assets/thumbnail-1.jpg";
import thumb2 from "../assets/thumbnail-2.jpg";
import thumb3 from "../assets/thumbnail-3.jpg";
import thumb4 from "../assets/thumbnail-4.jpg";
import bgImage from "../assets/bg.jpg";
import dg from "../assets/dg.png";
import puspak from "../assets/dr.webp";

const services = [
  {
    title: "PAIN CLINIC",
    description:
      "Pain management is a new branch of modern medicine that addresses all aspects of 'pain'. This is an emerging specialty in India, with new centres coming. ",
    icon: "🔥",
    color: "#ff6b6b",
  },
  {
    title: "CERVICAL CLINIC",
    description:
      "The goal of cervical spine surgery is to relieve pain,  tingling and weakness, restore nerve function and stop or prevent abnormal motion in the spine.",
    icon: "🦴",
    color: "#4ecdc4",
  },
  {
    title: "DEFORMITY CLINIC",
    description:
      "Scoliosis is an abnormal curvature of the spine that can occur in any age group. Kyphosis is seen when a person's spinal balance has moved too far forward.",
    icon: "🏥",
    color: "#45b7d1",
  },
  {
    title: "DEGENERATIVE CLINIC",
    description:
      "Disc degeneration is a disease of aging. In certain individuals a degenerated disc can cause severe chronic pain if left untreated.",
    icon: "⚕️",
    color: "#96ceb4",
  },
  {
    title: "ENDOSCOPY AND MINIMAL INVASIVE CLINIC",
    description:
      "Endoscopic laser spine surgery is a minimally invasive method of performing spinal surgery. Recovery is much faster.",
    icon: "🔬",
    color: "#ffcc5c",
  },
  {
    title: "OSTEOPOROSIS CLINIC",
    description:
      "Osteoporosis is a condition of fragile bone with an increased susceptibility to fracture. Patients have no symptoms until bone fractures occur.",
    icon: "💪",
    color: "#ff6f69",
  },
  {
    title: "TRAUMA & FACTURE CLINIC",
    description:
      "A spinal cord injury (SCI) that can refers to any injury to the spinal cord that is caused by trauma instead of disease.",
    icon: "🏃",
    color: "#88b8b0",
  },

  {
    title: "INFECTION CLINIC",
    description:
      "The vertebral column, intervertebral discs, dural sac or the space around the spinal cord may become infected by bacteria or fungal organisms.",
    icon: "🦠",
    color: "#f08a5d",
  },
  {
    title: "JOINT REPLACEMENT CLINIC",
    description:
      "A Joint Replacement Clinic specializes in diagnosing and treating severe joint pain and mobility issues caused by arthritis, injury, or degenerative conditions. ",
    icon: "🦿",
    color: "#6c5ce7",
  },

  {
    title: "ARTHROSCOPY & SPORTS MEDICINE CLINIC",
    description:
      "Our Arthroscopic and Sports Medicine department specializes in minimally invasive joint surgeries and comprehensive treatment of sports-related injuries. ",
    icon: "⚽", // Represents sports injury & athletic care
    color: "#0984e3",
  },
  {
    title: "PHYSIOTHERAPY AND REHAB CLINIC",
    description:
      "Our Physiotherapy and Rehab Clinic focuses on restoring movement, reducing pain, and improving strength through personalized therapy programs.",
    icon: "🏃‍♂️", // Represents movement & physical recovery
    color: "#00b894",
  },
];

const youtubeVideos = [
  {
    thumb: thumb1,
    link: "https://www.youtube.com/watch?time_continue=1&v=3u_Q2r2k2jI&embeds_referring_euri=http%3A%2F%2Fdrpuspaksamal.com%2F&source_ve_path=Mjg2NjY",
    title: "Spine Surgery Explained",
    views: "124K views",
    time: "10:25",
  },
  {
    thumb: thumb2,
    link: "https://www.youtube.com/watch?v=KeqX7nwJQy8&embeds_referring_euri=http%3A%2F%2Fdrpuspaksamal.com%2F&source_ve_path=Mjg2NjY",
    title: "Minimally Invasive Techniques",
    views: "89K views",
    time: "15:42",
  },
  {
    thumb: thumb3,
    link: "https://www.youtube.com/watch?v=MtJcjEdSqto",
    title: "Patient Recovery Stories",
    views: "56K views",
    time: "08:15",
  },
  {
    thumb: thumb4,
    link: "https://www.youtube.com/watch?v=TJY7JqqvZDI",
    title: "Advanced Orthopedic Care",
    views: "203K views",
    time: "12:30",
  },
  {
    thumb: thumb1,
    link: "https://www.youtube.com/watch?time_continue=1&v=3u_Q2r2k2jI&embeds_referring_euri=http%3A%2F%2Fdrpuspaksamal.com%2F&source_ve_path=Mjg2NjY",
    title: "Spine Health Tips",
    views: "67K views",
    time: "07:45",
  },
  {
    thumb: thumb4,
    link: "https://www.youtube.com/watch?time_continue=1&v=3u_Q2r2k2jI&embeds_referring_euri=http%3A%2F%2Fdrpuspaksamal.com%2F&source_ve_path=Mjg2NjY",
    title: "Surgical Innovations",
    views: "145K views",
    time: "18:20",
  },
];

const specialServices = [
  {
    img: Surgical,
    title: "Surgical Treatment",
    description:
      "Advanced surgical solutions including joint replacement, fracture fixation, and spine correction to restore function and quality of life.",
    icon: "🔪",
    link: "https://recommended-website.com/surgical",
  },
  {
    img: Phy,
    title: "Physical Therapy",
    description:
      "Personalized rehabilitation programs focused on pain relief, mobility restoration, and long-term recovery after injuries or surgery.",
    icon: "🤸",
    link: "https://recommended-website.com/physical-therapy",
  },
  {
    img: Diag,
    title: "Diagnostic",
    description:
      "Accurate diagnosis with the latest imaging and minimally invasive techniques to detect orthopedic conditions early and precisely.",
    icon: "🔍",
    link: "https://recommended-website.com/diagnostic",
  },
  {
    img: dg,
    title: "DG Shipping",
    description:
      "Global delivery of specialized orthopedic solutions, ensuring patients receive quality treatment options no matter where they are.",
    icon: "🚢",
    link: "https://www.seafarersassociation.com/",
  },
];

const Service = () => {
  const scrollContainerRef = useRef(null);
  const autoScrollInterval = useRef(null);

  const handleCardClick = (link) => {
    window.open(link, "_blank", "noopener noreferrer");
  };

  const getYouTubeVideoId = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  // Auto-scroll functionality
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const startAutoScroll = () => {
      autoScrollInterval.current = setInterval(() => {
        if (container) {
          const maxScrollLeft = container.scrollWidth - container.clientWidth;
          if (container.scrollLeft >= maxScrollLeft) {
            // Reset to start when reaching the end
            container.scrollTo({ left: 0, behavior: "smooth" });
          } else {
            // Scroll by one card width (approximately 400px)
            container.scrollBy({ left: 400, behavior: "smooth" });
          }
        }
      }, 4000); // Scroll every 4 seconds
    };

    const stopAutoScroll = () => {
      if (autoScrollInterval.current) {
        clearInterval(autoScrollInterval.current);
      }
    };

    // Start auto-scroll
    startAutoScroll();

    // Pause auto-scroll on hover
    container.addEventListener("mouseenter", stopAutoScroll);
    container.addEventListener("mouseleave", startAutoScroll);

    // Cleanup
    return () => {
      stopAutoScroll();
      if (container) {
        container.removeEventListener("mouseenter", stopAutoScroll);
        container.removeEventListener("mouseleave", startAutoScroll);
      }
    };
  }, []);

  return (
    <section className="py-5 bg-light" style={{ overflow: "hidden" }}>
      {/* Modern gradient background */}
      <div className="position-relative">
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient-primary opacity-10"></div>

        <div className="container position-relative">
          {/* Animated Header */}
          <motion.div
            className="text-center mb-5"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="badge bg-primary-soft text-primary px-4 py-2 rounded-pill mb-3">
              <i className="bi bi-heart-pulse-fill me-2"></i>
              Comprehensive Care
            </span>
            <h2 className="display-5 fw-bold text-dark mb-3">My Expertise</h2>
            <div className="divider mx-auto"></div>
            <p
              className="text-secondary mt-3"
              style={{ maxWidth: "600px", margin: "0 auto" }}
            >
              Specialized clinics focused on providing the highest quality
              orthopedic care
            </p>
          </motion.div>

          {/* Enhanced Swiper Slider with Interactive Cards */}
          <Swiper
            slidesPerView={1}
            spaceBetween={25}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{
              640: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 3 },
            }}
            modules={[Pagination, Autoplay, Navigation]}
            className="services-swiper pb-5"
          >
            {services.map((service, index) => (
              <SwiperSlide key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{
                    y: -10,
                    transition: { duration: 0.3 },
                  }}
                >
                  <Link
                    to={`/service/${service.title.toLowerCase().replace(/\s+/g, "-").replace(/[&]/g, "and")}`}
                    className="text-decoration-none"
                    style={{ display: "block", height: "100%" }}
                  >
                    <div
                      className="service-card-modern p-4 h-auto rounded-4 position-relative overflow-hidden"
                      style={{
                        background: "white",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                      }}
                    >
                      {/* Animated background gradient on hover */}
                      <motion.div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                          background: `linear-gradient(135deg, ${service.color}15 0%, ${service.color}05 100%)`,
                          opacity: 0,
                          transition: "opacity 0.3s ease",
                        }}
                        whileHover={{ opacity: 1 }}
                      />

                      {/* Corner accent */}
                      <div
                        className="position-absolute"
                        style={{
                          top: 0,
                          right: 0,
                          width: "50px",
                          height: "50px",
                          background: `linear-gradient(135deg, transparent 50%, ${service.color}20 50%)`,
                          borderBottomLeftRadius: "50%",
                        }}
                      />

                      <div className="d-flex align-items-center mb-3 position-relative">
                        <motion.span
                          className="service-icon rounded-circle me-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "60px",
                            height: "60px",
                            background: `${service.color}20`,
                            color: service.color,
                            fontSize: "28px",
                          }}
                          whileHover={{
                            rotate: 360,
                            scale: 1.1,
                            background: service.color,
                            color: "white",
                            transition: { duration: 0.5 },
                          }}
                        >
                          {service.icon}
                        </motion.span>
                        <h5
                          className="fw-bold text-dark mb-0"
                          style={{ fontSize: "1.1rem" }}
                        >
                          {service.title}
                        </h5>
                      </div>

                      <p
                        className="text-secondary mb-3 position-relative"
                        style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
                      >
                        {service.description}
                      </p>

                      {/* Learn more indicator */}
                      <motion.div
                        className="d-flex align-items-center position-relative"
                        style={{ color: service.color }}
                        initial={{ opacity: 0.5, x: -5 }}
                        whileHover={{ opacity: 1, x: 0 }}
                      >
                        <span className="small fw-semibold">Learn more</span>
                        <i className="bi bi-arrow-right-short ms-1"></i>
                      </motion.div>

                      {/* Bottom border animation */}
                      <motion.div
                        className="position-absolute bottom-0 start-0"
                        style={{
                          height: "3px",
                          background: service.color,
                          width: "0%",
                        }}
                        whileHover={{ width: "100%" }}
                        transition={{ duration: 0.3 }}
                      />
                    </div>
                  </Link>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* HORIZONTAL SCROLLING YOUTUBE SECTION - 80% WIDTH */}
      <div className="d-flex justify-content-center w-100">
        <div className="px-4 mt-5 mb-4" style={{ width: "90%" }}>
          <motion.div
            className="text-center mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <span className="badge bg-danger-soft text-danger px-4 py-2 rounded-pill mb-3">
              <i className="bi bi-youtube me-2"></i>
              Watch Our YouTube Channel
            </span>
            <h2 className="fw-bold mb-3">Educational Videos</h2>
            <div className="divider mx-auto"></div>
            <p
              className="text-secondary"
              style={{ maxWidth: "500px", margin: "0 auto" }}
            >
              Expert insights and educational content about orthopedic care
            </p>
          </motion.div>

          {/* Auto-scrolling Horizontal Container with Hidden Scrollbar */}
          <div
            ref={scrollContainerRef}
            className="horizontal-scroll-container youtube-scroll"
            style={{
              overflowX: "auto",
              overflowY: "hidden",
              whiteSpace: "nowrap",
              scrollbarWidth: "none", // Hide scrollbar for Firefox
              msOverflowStyle: "none", // Hide scrollbar for IE/Edge
              WebkitOverflowScrolling: "touch",
              paddingBottom: "20px",
              cursor: "grab",
              position: "relative",
            }}
          >
            <div
              style={{ display: "inline-flex", gap: "20px", padding: "30px" }}
            >
              {youtubeVideos.map((video, index) => {
                const videoId = getYouTubeVideoId(video.link);

                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.1 }}
                    viewport={{ once: true }}
                    style={{
                      width: "320px",
                      display: "inline-block",
                      whiteSpace: "normal",
                    }}
                  >
                    <div
                      className="youtube-card"
                      style={{
                        background: "white",
                        borderRadius: "8px",
                        overflow: "hidden",
                        cursor: "pointer",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                      }}
                      onClick={() => window.open(video.link, "_blank")}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-4px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 25px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 1px 2px rgba(0,0,0,0.1)";
                      }}
                    >
                      {/* Thumbnail Container - YouTube Style */}
                      <div className="position-relative">
                        <img
                          src={video.thumb}
                          alt={video.title}
                          style={{
                            width: "100%",
                            height: "180px",
                            objectFit: "cover",
                            backgroundColor: "#f0f0f0",
                          }}
                        />

                        {/* Duration Badge - YouTube Style */}
                        <div
                          style={{
                            position: "absolute",
                            bottom: "8px",
                            right: "8px",
                            background: "rgba(0,0,0,0.8)",
                            color: "white",
                            padding: "3px 6px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            fontWeight: "500",
                            fontFamily: "monospace",
                          }}
                        >
                          {video.time}
                        </div>

                        {/* Hover Play Button Overlay - YouTube Style */}
                        <motion.div
                          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                          style={{
                            background: "rgba(0,0,0,0.4)",
                            opacity: 0,
                            transition: "opacity 0.3s ease",
                          }}
                          whileHover={{ opacity: 1 }}
                        >
                          <div
                            style={{
                              width: "68px",
                              height: "48px",
                              background: "rgba(0,0,0,0.7)",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "2px solid white",
                              transition: "transform 0.2s ease",
                            }}
                            className="play-button-hover"
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="white"
                            >
                              <path d="M8 5v14l11-7z" />
                            </svg>
                          </div>
                        </motion.div>
                      </div>

                      {/* Video Info - YouTube Style */}
                      <div className="p-3">
                        <div className="d-flex">
                          {/* Channel Avatar Placeholder */}
                          <div
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "50%",
                              background:
                                "linear-gradient(135deg, #667eea, #764ba2)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "white",
                              fontWeight: "bold",
                              fontSize: "14px",
                              flexShrink: 0,
                            }}
                          >
                            DPS
                          </div>

                          {/* Title and Metadata */}
                          <div className="ms-3" style={{ flex: 1 }}>
                            <h6
                              className="fw-bold mb-1"
                              style={{
                                fontSize: "0.95rem",
                                lineHeight: "1.4",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}
                            >
                              {video.title}
                            </h6>
                            <div style={{ fontSize: "12px", color: "#606060" }}>
                              <div>Dr. Puspak Samal</div>
                              <div>
                                <span>{video.views}</span>
                                <span style={{ margin: "0 4px" }}>•</span>
                                <span>2 days ago</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>

          {/* Scroll Controls */}
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <motion.button
              className="btn btn-outline-danger rounded-circle"
              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                if (scrollContainerRef.current) {
                  scrollContainerRef.current.scrollBy({
                    left: -400,
                    behavior: "smooth",
                  });
                }
              }}
            >
              <i className="bi bi-chevron-left"></i>
            </motion.button>

            <motion.button
              className="btn btn-danger rounded-pill px-4"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() =>
                window.open(
                  "https://www.youtube.com/@Prof.Dr.PuspakSamalorthospinec",
                  "_blank",
                )
              }
            >
              <i className="bi bi-youtube me-2"></i>
              Subscribe to Channel
            </motion.button>

            <motion.button
              className="btn btn-outline-danger rounded-circle"
              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                if (scrollContainerRef.current) {
                  scrollContainerRef.current.scrollBy({
                    left: 400,
                    behavior: "smooth",
                  });
                }
              }}
            >
              <i className="bi bi-chevron-right"></i>
            </motion.button>
          </div>
        </div>
      </div>

      {/* Special Services Section with Interactive Cards */}
      <div className="container mt-2">
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <span className="badge bg-success-soft text-success px-4 py-2 rounded-pill mb-3">
            <i className="bi bi-stars me-2"></i>
            Specialized Treatments
          </span>
          <h2 className="fw-bold mb-3">Comprehensive Care Services</h2>
          <div className="divider mx-auto"></div>
          <p
            className="text-secondary"
            style={{ maxWidth: "600px", margin: "0 auto" }}
          >
            Advanced medical solutions tailored to your specific needs
          </p>
        </motion.div>

        <div className="row g-3">
          {specialServices.map((service, index) => (
            <motion.div
              key={index}
              className="col-lg-3 col-md-6"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <motion.div
                className="special-service-card position-relative rounded-2 overflow-hidden"
                whileHover={{ y: -10 }}
                transition={{ duration: 0.3 }}
                onClick={() => handleCardClick(service.link)}
                style={{ cursor: "pointer" }}
              >
                <div className="position-relative">
                  <img
                    src={service.img}
                    alt={service.title}
                    className="img-fluid d-block mx-auto"
                    style={{ height: "180px", width: "auto" }}
                  />
                  {/* Overlay with icon */}
                  <motion.div
                    className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                      background: `linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%)`,
                      opacity: 0,
                    }}
                    whileHover={{ opacity: 1 }}
                  >
                    <motion.div
                      className="text-center text-white p-1"
                      initial={{ scale: 0.5, opacity: 0 }}
                      whileHover={{ scale: 1, opacity: 1 }}
                      transition={{ delay: 0.1 }}
                    >
                      <span className="display-4 mb-2 d-block">
                        {service.icon}
                      </span>
                      <h5 className="fw-bold mb-2">{service.title}</h5>
                      <p className="small mb-0">{service.description}</p>
                    </motion.div>
                  </motion.div>

                  {/* Service badge */}
                  <div
                    className="service-badge position-absolute"
                    style={{
                      top: "15px",
                      right: "15px",
                      width: "40px",
                      height: "40px",
                      background: "white",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                    }}
                  >
                    {service.icon}
                  </div>
                </div>

                <div className="p-4 bg-white">
                  <h5 className="fw-bold mb-2">{service.title}</h5>
                  <p className="text-secondary small mb-0">
                    {service.description}
                  </p>

                  {/* Hover indicator */}
                  <motion.div
                    className="mt-3 text-primary d-flex align-items-center"
                    initial={{ opacity: 0.5 }}
                    whileHover={{ opacity: 1, x: 5 }}
                  >
                    <span className="small fw-semibold">View details</span>
                    <i className="bi bi-arrow-right ms-1"></i>
                  </motion.div>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Add custom CSS */}
      <style jsx>{`
        .bg-primary-soft {
          background: rgba(102, 126, 234, 0.1);
        }
        .bg-success-soft {
          background: rgba(40, 167, 69, 0.1);
        }
        .bg-danger-soft {
          background: rgba(220, 53, 69, 0.1);
        }
        .divider {
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2);
          border-radius: 2px;
        }
        .service-card-modern {
          background: white;
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
          border: 1px solid rgba(0, 0, 0, 0.05);
        }
        .service-card-modern:hover {
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
          border-color: transparent;
        }
        .service-icon {
          transition: all 0.3s ease;
        }
        .special-service-card {
          background: white;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .special-service-card:hover {
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        }

        /* Hide scrollbar for Chrome, Safari and Opera */
        .horizontal-scroll-container::-webkit-scrollbar {
          display: none;
        }

        /* Hide scrollbar for IE, Edge and Firefox */
        .horizontal-scroll-container {
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
        }

        .youtube-card {
          transition: all 0.3s ease;
        }

        .play-button-hover {
          transition: transform 0.2s ease;
        }

        .youtube-card:hover .play-button-hover {
          transform: scale(1.05);
        }

        .video-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .video-card:hover .video-overlay {
          opacity: 1;
        }
        .play-button {
          width: 60px;
          height: 60px;
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(5px);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid white;
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }
        .card-modern {
          background: white;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
        }
        .card-modern:hover {
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        }
        .card-icon-overlay {
          position: absolute;
          top: 15px;
          right: 15px;
        }
        .service-badge {
          width: 40px;
          height: 40px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }
        .special-service-card:hover .service-badge {
          transform: scale(1.1);
          background: linear-gradient(135deg, #667eea, #764ba2);
          color: white;
        }
        .floating-shape-1 {
          position: absolute;
          top: -100px;
          right: -100px;
          width: 300px;
          height: 300px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          animation: float 8s infinite;
        }
        .floating-shape-2 {
          position: absolute;
          bottom: -100px;
          left: -100px;
          width: 250px;
          height: 250px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          animation: float 6s infinite reverse;
        }
        @keyframes float {
          0% {
            transform: translate(0, 0) rotate(0deg);
          }
          50% {
            transform: translate(30px, 30px) rotate(180deg);
          }
          100% {
            transform: translate(0, 0) rotate(360deg);
          }
        }
        .doctor-image-wrapper {
          position: relative;
          padding: 20px;
        }
        .floating-bg-shape {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #667eea20 0%, #764ba220 100%);
          border-radius: 30px;
          transform: rotate(-3deg);
          z-index: 1;
        }
        .experience-badge {
          position: absolute;
          bottom: 30px;
          right: 30px;
          background: white;
          padding: 15px 25px;
          border-radius: 50px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          align-items: center;
          z-index: 3;
        }
        .experience-badge .years {
          font-size: 24px;
          font-weight: 700;
          color: #667eea;
          line-height: 1;
        }
        .experience-badge .text {
          font-size: 12px;
          color: #666;
        }
        .signature-line {
          width: 50px;
          height: 2px;
          background: linear-gradient(90deg, #667eea, #764ba2);
        }
        .text-white-50 {
          color: rgba(255, 255, 255, 0.7) !important;
        }
        .shadow-xl {
          box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
        }
      `}</style>
    </section>
  );
};

export default Service;
